/** How often to poll a matter's member list. */
export const kMembersPollingIntervalMs = 30 * 1000 // 30 seconds

/** How long a fetched member list stays fresh before a non-forced fetch will refetch it. */
export const kMembersCacheDurationMs = 30 * 1000 // 30 seconds
